// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwStepProgress from 'viewmodel/AwStepProgressViewModel';
    import { ExistWhen,AwClass } from 'js/hocCollection';
const AwButtonExistWhenAwClass = AwClass(ExistWhen(AwButton));
const AwFlexRowExistWhen = ExistWhen(AwFlexRow);
AwButtonExistWhenAwClass.displayName = 'AwButtonExistWhenAwClass';
AwFlexRowExistWhen.displayName = 'AwFlexRowExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesFileUploadSampleService', () => import('js/DesFileUploadSampleService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "lifecycleHooks": {
        "onMount": "getUploadTicket",
        "onUpdate": {
            "observers": [
                "props.accsessionid"
            ]
        }
    },
    "data": {
        "isUploading": false,
        "directory": true,
        "filesForLibrary": {
            "displayName": "{{i18n.chooseFilesToUpload}}",
            "type": "STRING"
        },
        "isThumbnailSelected": false,
        "setCreateStagingAreaFlag": false,
        "currentStep": {
            "displayName": "Current Background Job Step",
            "type": "STRING",
            "dispValue": "Creating Staging Area"
        },
        "steps": [
            {
                "dbValue": "Defining",
                "isCurrentActive": true,
                "isCompleted": false,
                "isInProgress": false,
                "propertyDisplayName": "Creating Staging Area"
            },
            {
                "dbValue": "Detailing",
                "propertyDisplayName": "Adding Files to Staging Area"
            },
            {
                "dbValue": "Reviewing",
                "propertyDisplayName": "Uploading Files"
            },
            {
                "dbValue": "Done",
                "propertyDisplayName": "Importing Files to Library"
            },
            {
                "dbValue": "Obsolete",
                "propertyDisplayName": "Completed"
            }
        ]
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "uploadticket": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        }
    },
    "actions": {
        "navigate": {
            "actionType": "JSFunction",
            "method": "getNextStep",
            "inputData": {
                "steps": "{{data.steps}}"
            },
            "outputData": {
                "currStep": "currentStep",
                "previousStep": "previousStep",
                "currentStep.dbValue": "currentStep.propertyDisplayName",
                "currentStep.uiValue": "currentStep.propertyDisplayName"
            },
            "deps": "js/DesFileUploadSampleService"
        },
        "getSelectedFileInfo": {
            "actionType": "JSFunctionAsync",
            "method": "getSelectedFileInfo",
            "inputData": {
                "parameters": "{{parameters}}"
            },
            "outputData": {
                "dataToBeRelated": "dataToBeRelated",
                "fileInputForms": "fileInputForms",
                "stageAreaFileInfo": "stageAreaFileInfo"
            },
            "deps": "js/DesFileUploadSampleService"
        },
        "uploadFiles": {
            "actionType": "JSFunctionAsync",
            "method": "uploadFiles",
            "inputData": {
                "accsessionid": "{{props.accsessionid}}",
                "files": "{{data.fileInputForms}}",
                "stageAreaFileInfo": "{{data.filesAddedInStagingArea.output.data.results}}",
                "maxChunkSize": null,
                "concurrencyLimit": null,
                "endpointConfig": {
                    "upload": "/acc/fileUpload",
                    "chunkUpload": "/acc/chunkUpload"
                }
            },
            "deps": "js/DesFileUploadSampleService"
        },
        "createStagingArea": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library"
                        },
                        "query": "mutation createStagingArea( $createStagingAreaInput: CreateStagingAreaInput) { createStagingArea( createStagingAreaInput: $createStagingAreaInput ) }",
                        "variables": {
                            "createStagingAreaInput": {
                                "parentFolderId": "",
                                "stagingAreaType": "BMECat"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "createStagingArea": "data.data.createStagingArea"
            },
            "events": {},
            "actionMessages": {},
            "deps": "js/accHttpService"
        },
        "AddFilesToStagingArea": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library",
                            "stagingAreaId": "{{data.createStagingArea.output.data.stagingAreaId}}"
                        },
                        "query": "mutation addFilesToStagingArea( $addFilesToStagingAreaInput: AddFilesToStagingAreaInput) { addFilesToStagingArea( addFilesToStagingAreaInput: $addFilesToStagingAreaInput ) }",
                        "variables": {
                            "addFilesToStagingAreaInput": {
                                "fileList": "{{data.dataToBeRelated.stageAreaFileInfo}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "filesAddedInStagingArea": "data.data.addFilesToStagingArea",
                "accUrl": "data.data.addFilesToStagingArea.accUrl"
            },
            "events": {
                "failure": [
                    {
                        "name": "desaddFilesToStagingAreaFailure",
                        "eventData": {
                            "eventData": "{{filesAddedInStagingArea}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desaddFilesToStagingAreaSuccess",
                        "eventData": {
                            "eventData": "{{filesAddedInStagingArea}}"
                        }
                    }
                ]
            },
            "actionMessages": {},
            "deps": "js/accHttpService"
        },
        "perfromImport": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {},
                        "query": "mutation performImport ( $collaborationspaceId: String, $containerType: String, $containerId: String, $stagingAreaId: String ) { performImport( collaborationspaceId: $collaborationspaceId, containerType: $containerType,containerId: $containerId, stagingAreaId: $stagingAreaId)}",
                        "variables": {
                            "collaborationspaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library",
                            "stagingAreaId": "{{data.createStagingArea.output.data.stagingAreaId}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "performImport": "data.data.performImport"
            },
            "events": {
                "failure": [
                    {
                        "name": "desperfromImportFailure",
                        "eventData": {
                            "eventData": "{{performImport}}"
                        },
                        "condition": "conditions.performImportCondition"
                    }
                ],
                "success": [
                    {
                        "name": "desperfromImportSuccess",
                        "eventData": {
                            "eventData": "{{performImport}}"
                        },
                        "condition": "conditions.performImportCondition"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "toggleUploadingFlag": {
            "actionType": "JSFunction",
            "method": "toggleUploadingFlag",
            "inputData": {
                "isUploading": "{{parameters.isUploading}}"
            },
            "outputData": {
                "isUploading": "isUploading"
            },
            "deps": "js/DesFileUploadSampleService"
        },
        "perfromBatchActionForSupplierPerfromImport": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "toggleUploadingFlag",
                    "inputArg": {
                        "isUploading": true
                    }
                },
                {
                    "action": "createStagingArea"
                },
                {
                    "action": "navigate"
                },
                {
                    "action": "AddFilesToStagingArea"
                },
                {
                    "action": "navigate"
                },
                {
                    "action": "uploadFiles"
                },
                {
                    "action": "navigate"
                },
                {
                    "action": "perfromImport"
                },
                {
                    "action": "navigate"
                },
                {
                    "action": "toggleUploadingFlag",
                    "inputArg": {
                        "isUploading": false
                    }
                }
            ]
        },
        "actionOnStepClicked": {
            "actionType": "JSFunction",
            "method": "stepClickedMethod",
            "inputData": {
                "steps": "{{data.steps}}",
                "selectedStep": "{{parameters}}"
            },
            "outputData": {
                "steps": "steps",
                "currStep": "currentStep",
                "currentStep.dbValue": "currentStep.propertyDisplayName",
                "currentStep.uiValue": "currentStep.propertyDisplayName"
            },
            "deps": "js/DesFileUploadSampleService"
        }
    },
    "onEvent": [
        {
            "eventId": "desperfromImportSuccess",
            "message": "performImportSuccessMsg"
        }
    ],
    "messages": {
        "invalidFileError": {
            "messageType": "WARNING",
            "messageText": "{{i18n.invalidFileError}}",
            "navigationOptions": [
                {
                    "option": "Cancel",
                    "text": "{{i18n.CancelText}}"
                }
            ]
        },
        "performImportSuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.fileUploadSuccessMsg}}"
        }
    },
    "conditions": {
        "enablePerfromImportButton": {
            "expression": "data.fileInputForms.length > 0"
        },
        "displaySupplierFileUpload": {
            "expression": "props.isSupplier === 'true'"
        },
        "performImportCondition": {
            "expression": "performImport.output.success"
        }
    },
    "i18n": {
        "invalidFileError": [
            "DesLibraryMessages"
        ],
        "fileUploadSuccess": [
            "DesLibraryMessages"
        ],
        "filesForLibrary": [
            "DesLibraryMessages"
        ],
        "removeFileBtnTooltip": [
            "DesLibraryMessages"
        ],
        "createStagingArea": [
            "DesLibraryMessages"
        ],
        "addFilesToStagingArea": [
            "DesLibraryMessages"
        ],
        "catalogInfo": [
            "DesLibraryMessages"
        ],
        "fileUploadSuccessMsg": [
            "DesLibraryMessages"
        ],
        "chooseFilesToUpload": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesFileUploadSample",
    "_uniqueViewModelId": "DesFileUploadSample",
    "ctx": {}
};

    /*
    <aw-panel class="afx-content-background aw-layout-full">
	<aw-panel-body>
		<aw-label prop="data.filesForLibrary"></aw-label>
		<aw-file-upload file-change-action="getSelectedFileInfo" multiple="{{true}}"
			remove-tooltip="{{i18n.removeFileBtnTooltip}}" webkitdirectory="{{data.directory}}">
		</aw-file-upload>
	</aw-panel-body>

	<aw-panel-footer>
		<aw-button exist-when="!data.isUploading" class='small' aw-class="[{ 'disabled': data.isUploading }]"
			button-type='accent-high-contrast' size='stretched'
			action='perfromBatchActionForSupplierPerfromImport'>Upload Files
		</aw-button>
		<aw-flex-row height="4f"  exist-when="data.isUploading">
			<aw-flex-column align-content="start">
				<aw-step-progress current-step="data.currStep"
					step-click-action="actionOnStepClicked" steps="data.steps" completed-step="data.previousStep"
					clickable="true"></aw-step-progress>
			</aw-flex-column>
		</aw-flex-row>
	</aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="afx-content-background aw-layout-full">
        <AwPanelBody>
            <AwLabel {...getField("data.filesForLibrary", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} fileChangeAction={actions.getSelectedFileInfo} multiple={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} removeTooltip={AwParseService.instance( "i18n.removeFileBtnTooltip" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} webkitdirectory={AwParseService.instance( "data.directory" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </AwFileUpload>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonExistWhenAwClass className="small" buttonType="accent-high-contrast" size="stretched" action={actions.perfromBatchActionForSupplierPerfromImport} existWhen={AwParseService.instance( "!data.isUploading" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} awClass={AwParseService.instance( "[{ 'disabled': data.isUploading }]" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                Upload Files
            </AwButtonExistWhenAwClass>
            <AwFlexRowExistWhen height="4f" existWhen={AwParseService.instance( "data.isUploading" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwFlexColumn alignContent="start">
                    <AwStepProgress currentStep={AwParseService.instance( "data.currStep" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} stepClickAction={actions.actionOnStepClicked} steps={AwParseService.instance( "data.steps" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} completedStep={AwParseService.instance( "data.previousStep" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} clickable={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    </AwStepProgress>
                </AwFlexColumn>
            </AwFlexRowExistWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;